const LOCALES = {
  ENGLISH: "en",
  ITALIAN: "it",
  FRENCH: "fr",
  GERMAN: "de",
  SPANISH: "es",
};

export default LOCALES;
